module.exports = __webpack_public_path__ + "static/media/hero_kitchen-min.d15b408c.png";